// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import Info from "./pages/Info";
import How from "./pages/How";
import "./App.css";

const BG_URL = process.env.PUBLIC_URL + "/frog-bg.png";

function App() {
  return (
    <Router>
      {/* background applied here once for EVERY page */}
      <div
        className="App"
        style={{
          backgroundImage: `url(${BG_URL})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
        }}
      >
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/info" element={<Info />} />
          <Route path="/how-it-works" element={<How />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;